var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner"},[_c('i',{staticClass:"fas fa-circle-notch fast-spin",style:({ fontSize: _vm.size })})])])}
var staticRenderFns = []

export { render, staticRenderFns }